import { FlowConfig } from 'dto/FlowConfig';
import { NodeUi } from 'classes/NodeUi';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { EDITORTYPE, MetaDataPropertyDto, MetaDataDto } from "dto/MetadataDto";

@Component({
  selector: 'metadata-controls',
  templateUrl: './metadata-controls.component.html',
  styleUrls: ['./metadata-controls.component.css']
})
export class MetadataControlsComponent implements OnInit {
  
  @Input() metaData:MetaDataDto; 
  @Input() node:NodeUi;
  @Input() expressionedProperties:string[];

  dataValue:any = null;
  // Code below enables 2-way-binding on the data object.
  @Input()
  get data(){
    return this.dataValue;
  }
  set data(val) {
    this.dataValue = val;
    this.dataChange.emit(this.dataValue);
  }
  
  @Output() dataChange = new EventEmitter();

  // Bind static class, otherwise it isn't accessible.
  EDITOR = Editor;
  EDITORTYPE = EDITORTYPE;

  constructor() {
  }

  ngOnInit() {
    if(!this.data){
      // Act on dataValue instead of on the @Input data to prevent ExpressionChangedAfterItHasBeenCheckedError
      this.dataValue = {};
      this.dataChange.emit(this.dataValue);
    }
    this.metaData.Properties.forEach(x => {
      if (x.ForceEvaluation || x.Editor == EDITORTYPE.EXPRESSION)
      {
        if (!this.expressionedProperties)
          this.expressionedProperties = [];
        if (!this.expressionedProperties.some(y => y == x.PropertyName))
          this.expressionedProperties.push(x.PropertyName)
      }
    });
  }

  public addToCollection(prop:any):void {
    if(this.data[prop.PropertyName] == null)
      this.data[prop.PropertyName] = [];
    
    let item = { };
    for(let p of prop.NestedMetaData.Properties)
      item[p.PropertyName] = null;

    this.data[prop.PropertyName].push(item); 
  }
  
  public removeFromCollection(prop:string,index:any):void {    
    this.data[prop].splice(index,1);
  }

  public flowPickerUpdate(flowId:string, prop:any)
  {
    this.data[prop.PropertyName] = flowId;
  }

  toggleExpression(prop:MetaDataPropertyDto){
    let ix = this.expressionedProperties.indexOf(prop.PropertyName);
    if(ix >= 0){
        this.expressionedProperties.splice(ix,1);

      if(prop.DefaultValue)
        this.data[prop.PropertyName] = prop.DefaultValue;   
      else
        delete this.data[prop.PropertyName];
    }
    else {
      this.expressionedProperties.push(prop.PropertyName); 
      this.data[prop.PropertyName] = null;
    }
    
  }

  isExpression(key:string) {
    return this.expressionedProperties && this.expressionedProperties.some(x => x == key);
  }

}

export class Editor {

  //public static getHTMLInputTypeNames():string[]
  
  //Very strange way of creating a static array, but this was the only way I managed to get it both working and maintainable.
  //Pay attention, that's a static anonymous function that is called only once, directly after its creation, and then discarded.
  /** Mapping from EDITORTYPE.<something> to the corresponding HTML5 string X in <input type="X"> */
  public static readonly HTMLINPUTNAMES = function() {
    let result = [];
    result[EDITORTYPE.TEXTINPUT] = "text";
    result[EDITORTYPE.CHECKBOX] = "checkbox";
    result[EDITORTYPE.NUMBERINPUT] = "number";
    result[EDITORTYPE.COLORINPUT] = "color";
    result[EDITORTYPE.DATEINPUT] = "date";
    result[EDITORTYPE.LOCALDATETIMEINPUT] = "localdatetime";
    result[EDITORTYPE.EMAILINPUT] = "email";
    result[EDITORTYPE.MONTHYEARINPUT] = "month";
    result[EDITORTYPE.RANGEINPUT] = "range";
    result[EDITORTYPE.SEARCHINPUT] = "search";
    result[EDITORTYPE.TELEPHONEINPUT] = "tel";
    result[EDITORTYPE.TIMEINPUT] = "time";
    result[EDITORTYPE.URLINPUT] = "url";
    result[EDITORTYPE.WEEKINPUT] = "week";
    // Count the total number of types.
    let numtypes = Object.keys(EDITORTYPE).length;
    if (result.length < numtypes)
      // Explicitly define the last (non-HTML input) entry in result, to avoid out-of-bounds exceptions when someone makes a mistake.
      result[numtypes] = null;
    return result;
  }();
}


// WEBPACK FOOTER //
// C:/git/flowdesigner/src/app/metadata-controls/metadata-controls.component.ts